import React, { useRef, useState } from 'react';
import { InfoOutlined } from '@mui/icons-material';
import { Popover, PopoverOrigin, styled } from '@mui/material';

import './ReusableBuilderPreview.scss';

const PopoverConfig = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  } as PopoverOrigin,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right',
  } as PopoverOrigin,
};

const ImageContainer = styled('div')({ padding: '0 20px' });
const Image = styled('img')({ maxWidth: '100%', maxHeight: '100%' });

export default function TransformBuilderPopover() {
  const infoReference = useRef(null);
  const [popover, setPopover] = useState(false);

  return (
    <>
      <span className="title">
        Transform Builder Preview
        <div
          ref={infoReference}
          aria-describedby="info-reference-element"
          onClick={() => setPopover((s) => !s)}
        >
          <InfoOutlined fontSize="small" />
        </div>
        {popover ? <div className="modal-fader" /> : null}
        <Popover
          id="info-reference-element"
          open={popover}
          style={{ maxWidth: '800px' }}
          anchorEl={infoReference.current}
          onClose={() => setPopover((s) => !s)}
          anchorOrigin={PopoverConfig.anchorOrigin}
          transformOrigin={PopoverConfig.transformOrigin}
        >
          <div className="popover_container" style={{ zIndex: 6 }}>
            <p className="popover_title">Transform Builder Mode in the Nexset Designer</p>
            <p className="popover_content">
              The Transform Builder Preview shows a preview of the pulldown menus and/or text fields
              that will be shown to users who apply this transform using Transform Builder mode in
              the Nexset Designer.
            </p>
            <p className="popover_content">
              The associated pulldown menus and/or text fields that will be shown to users of the
              transform are listed under each function argument.
            </p>
            <ImageContainer>
              <Image
                alt="tx-builder screenshot"
                loading="lazy"
                src="https://cdn.nexla.io/ui/assets/designer/ui-nexset-designer-tx-builder-preview.png"
              />
            </ImageContainer>
          </div>
        </Popover>
      </span>
    </>
  );
}
